import { People as MitarbeiterIcon } from '@mui/icons-material';

import { AppFeature } from '../../components/dcbApp/types';

import { MitarbeiterListScreen } from './list/MitarbeiterListScreen';
import { MitarbeiterDialogForm } from './save/MitarbeiterDialogForm';
import { MitarbeiterViewScreen } from './view/MitarbeiterViewScreen';

export const mitarbeiterFeature: AppFeature = {
  path: 'mitarbeiter',
  label: 'Mitarbeiter',
  icon: <MitarbeiterIcon sx={{ color: 'secondary.main' }} />,
  list: <MitarbeiterListScreen />,
  view: <MitarbeiterViewScreen />,
  dialogs: [<MitarbeiterDialogForm />],
};
